import DpiJourneyType from "@trainline/dpi/lib/types/JourneyType";
const SearchType = {
  Single: DpiJourneyType.Single,
  Return: DpiJourneyType.Return,
  OpenReturn: DpiJourneyType.OpenReturn,
  Seasons: "seasons"
};
export {
  SearchType
};
